module.exports = __webpack_public_path__ + "media/promo/courses/images/s1-c2fe15c5d3fd3d30df2fb62ec43cdec2.svg";